import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLoading } from "../Context/LoadingProvider";
//import { useUser } from "../Context/UserProvider";
import { useTranslation } from "react-i18next";
import { patrollerService, DashboardInformation } from "../Api/Services/PatrollerService";
import profilePlaceholder from "../Assets/gfx/profile.png";
import { LongArrowLeftIcon } from "../Components/Icons/LongArrowLeftIcon";
import CircleProgress from "../Components/CircleProgress";
import { GoalIcon } from "../Components/Icons/GoalIcon";

const Dashboard: React.FunctionComponent<object> = () => {
    const { startLoading, finnishLoading } = useLoading();
    const { t } = useTranslation();
    const [dasboardInformation, setDashboardInformation] = useState<DashboardInformation | null>(null);
    //const { user } = useUser();

    const [activeTab, setActiveTab] = useState<string>("thisMonth"); // Aktív fül állapota

    useEffect(() => {
        startLoading("dashboard");
        patrollerService.getDashboardInformation().then((res) => {
            setDashboardInformation(res);
            console.log(res);
            finnishLoading("dashboard");
        });
        //eslint-disable-next-line
    }, []);

    const [rating, setRating] = useState<number>(0);
    useEffect(() => {
        if (dasboardInformation?.kpiStatistics?.score) {
            const score = dasboardInformation.kpiStatistics.score;
            if (score >= 111) {
                setRating(5);
            } else if (score >= 101) {
                setRating(4);
            } else if (score >= 95) {
                setRating(3);
            } else if (score >= 85) {
                setRating(2);
            } else {
                setRating(1);
            }
        }
    }, [dasboardInformation]);

    const ratingToText = (rating: number) => {
        switch (rating) {
            case 1:
                return t("Underperforming");
            case 2:
                return t("Needs Improvement");
            case 3:
                return t("Meets Expectations");
            case 4:
                return t("Exceeds Expectations");
            case 5:
                return t("Outstanding");
            default:
                return "";
        }
    }

    return (
        <div className="view-container view-container--stretch background">
            <div className="view-content h-full flex flex-col justify-between">

                 <div>
                    <div className="navigationbar mb-6">
                        <div className="navigationbar__left">
                            <Link to="/menu" className="navigationbar__button">
                                <LongArrowLeftIcon />
                            </Link>
                        </div>
                        <div className="navigationbar__center"></div>
                        <div className="navigationbar__right">
                            
                        </div>
                    </div>
                </div>
                <div className="inner-view-container">

                    <div className="rider-profile-header">
                        <div className="rider-profile-header__left"></div>
                        <div className="rider-profile-header__center flex justify-center">
                            <div className="user-avatar">
                                <img src={profilePlaceholder} alt="" width="100" height="100"/>
                            </div>
                        </div>
                        <div className="rider-profile-header__right"></div>
                    </div>
              

                    <div className="content-padding background-white" style={{paddingTop: '15px', paddingBottom: "15px"}}> 
                        {/*<div className="heading text-center">{user?.name}</div> */}     

                        <div className="card mb-4"> 
                            <div className="text-light mb-2">{t("Daily Plan")}</div>

                            <div className="flex gap-2">
                                <div className="relative" style={{ 
                                    width: "44px",
                                    height: "44px"
                                }}>
                                    <CircleProgress progress={Number(dasboardInformation?.currentDailyGoal) === 0
                                        ? 100
                                        : Math.round(
                                        ((dasboardInformation?.checksToday ?? 0) /
                                            (Number(dasboardInformation?.currentDailyGoal) ?? 30)) *
                                        100
                                    )} size={44} thickness={4} />

                                    <div style={{ 
                                        position: 'absolute', 
                                        top: "50%", 
                                        left: "50%",
                                        transform: "translate(-50%,-50%)"
                                    }}>
                                        <GoalIcon/>
                                    </div>
                                </div>
                                <div>
                                    <div className="text-large text-purple">
                                        {dasboardInformation?.checksToday}/{dasboardInformation?.currentDailyGoal}
                                    </div>
                                    <div className="text-light">
                                        {t("Check " + (dasboardInformation?.currentDailyGoal ?? 30) + " Riders")}
                                    </div>
                                </div>
                            </div>
                        </div> 
                    
                        <div className="mb-4">
                            <div className="tab-view">
                                <div className="tabnavigation">
                                    <button
                                        className={`tabnavigation__item ${activeTab === "thisMonth" ? "active" : ""}`}
                                        onClick={() => setActiveTab("thisMonth")}
                                    >
                                        {t("This Month")}
                                    </button>
                                    <button
                                        className={`tabnavigation__item ${activeTab === "lastMonth" ? "active" : ""}`}
                                        onClick={() => setActiveTab("lastMonth")}
                                    >
                                        {t("Last Month")}
                                    </button>
                                </div>
                            </div>
                        <div className="tab-view__content pt-4">
                                {activeTab === "thisMonth" && (
                                    <div>
                                        <table className="dp-table">
                                            <tbody>
                                            <tr>
                                                <td className="">{t("Number of audits:")}</td>
                                                <td className="dp-table__marked">{dasboardInformation?.checksCurrentMonth ?? 0} / {dasboardInformation?.thisMonthGoals ?? 0}</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t("Audit score:")}</td>
                                                <td className="dp-table__marked">0</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t('Accuracy')}</td>
                                                <td className="dp-table__marked">0</td>
                                            </tr>
                                            {/*<tr>
                                                <td className="">{t('Survey')}</td>
                                                <td className="dp-table__marked">0</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t('Assessment')}</td>
                                                <td className="dp-table__marked">0</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t('Attendance')}</td>
                                                <td className="dp-table__marked">0</td>
                                            </tr>*/}
                                            <tr>
                                                <td className="">{t('Shift Score')}</td>
                                                <td className="dp-table__marked">0</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t('Date')}</td>
                                                <td className="dp-table__marked"> - </td>
                                            </tr>
                                            <tr>
                                                <td className="">{t("Final score:")}</td>
                                                <td className="dp-table__marked">{dasboardInformation?.currentFinalGoal ?? 0} pt</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                                {activeTab === "lastMonth" && (
                                    <div>
                                        <table className="dp-table">
                                            <tbody>
                                            <tr>
                                                <td className="">{t("Number of audits:")}</td>
                                                <td className="dp-table__marked">{dasboardInformation?.kpiStatistics?.total ?? 0}</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t("Audit score:")}</td>
                                                <td className="dp-table__marked">{dasboardInformation?.kpiStatistics?.auditscore ?? 0}</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t('Accuracy')}</td>
                                                <td className="dp-table__marked">{dasboardInformation?.kpiStatistics?.accuracy ?? 0}</td>
                                            </tr>
                                            {/*<tr>
                                                <td className="">{t('Survey')}</td>
                                                <td className="dp-table__marked">{dasboardInformation?.kpiStatistics?.survey ?? 0}</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t('Assessment')}</td>
                                                <td className="dp-table__marked">{dasboardInformation?.kpiStatistics?.assessment ?? 0}</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t('Attendance')}</td>
                                                <td className="dp-table__marked">{dasboardInformation?.kpiStatistics?.attendance ?? 0}</td>
                                            </tr>*/}
                                            <tr>
                                                <td className="">{t('Shift Score')}:</td>
                                                <td className="dp-table__marked">{dasboardInformation?.kpiStatistics?.shift_score ?? 0}</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t('Date')}</td>
                                                <td className="dp-table__marked">{dasboardInformation?.kpiStatistics?.scoreDate ?? "-"}</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t("Final score:")}</td>
                                                <td className="dp-table__marked">{dasboardInformation?.kpiStatistics?.score ?? 0} pt</td>
                                            </tr>
                                            <tr>
                                                <td className="">{t("Rating")}:</td>
                                                <td className="dp-table__marked">{rating} ({ratingToText(rating)})</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>


                        
                        </div>

                        {/*<div className="flex flex-col items-center mt-6">
                            <button onClick={() => navigate("/daily-goal-requests")} className="button">
                                {t("Daily Goal Requests")}
                            </button>
                        </div>*/}
                        
                    </div>
                    </div>
            </div>
        </div>
    );
};

export default Dashboard;
